import type { WorldState } from "../../models/worldState.ts";
import type { ReduceResult } from "../result.ts";

export function reduceCompleteSettle(state: WorldState): ReduceResult {
  const revealedTileCount = Object.values(state.tiles).filter(
    (entry) => entry.visibility === "revealed",
  ).length;

  return {
    state: {
      ...state,
      phase: "playing",
    },
    events: [{ type: "PlayingStarted", revealedTileCount }],
  };
}
